<template>
<div>
  <div class="row justify-content-center">
    <div class="col-md-12 col-11" >
          <div class="row justify-content-center" style="background:#f6f6f6;">
            <div class="col-md-12">
              <br>
                  <center>
                          <p>Selecciona:</p> 
                          <div class="row justify-content-center">
                            <div class="col-md-2">
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#E63780; border-color:#E63780;" 
                                @click="cambioSelect(1)">
                                Nuevas solicitudes
                              </button> 
                            </div>
                            <div class="col-md-2">
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#F28D15; border-color:#F28D15;" 
                                @click="cambioSelect(2)">
                                En proceso 
                              </button> 
                            </div> 
                            <div class="col-md-2">
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#A13EA1; border-color:#A13EA1;" 
                                @click="cambioSelect(0)">
                                Cerradas
                              </button> 
                            </div>
                          </div>
                  </center>
              <br>
            </div>  
        </div> 
    </div>
    <div class="col-md-12 col-11" > 
      <br v-if="isMobile"> 
      <br> 
       <div class="form-group mt-5 ">
         <div class="row">
          <div class="col-md-1"></div>  
            <div class="col-md-2 mt-5" >
                <div class="input-group" :style="isMobile ? '' : 'margin-left: -15px;'">
                    <input type="text" v-model="buscar" class="form-control " placeholder="Buscar No. Folio" style="border-radius: 30px;"> 
                </div>
            </div>
            <div class="col-md-2" v-if="cambio_solicitud == 0" >
               <div class="d-flex">
                  <button  class="btn float-center btn-sm mt-5 btn-block" type="button" :style="historico == 0 ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615;'
                   : 'font-size:16px; color:#fff; border-radius: 26px;  background:#888383; border-color:#888383;'" 
                    @click="historico = 0">
                    Vigente
                  </button>  
                  <button  class="btn float-center btn-sm mt-5  btn-block ml-2"  type="button" :style="historico == 0 ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#888383; border-color:#888383;  z-index:2;'
                   : 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; z-index:2;'"
                    @click="historico = 1">
                    Histórico
                  </button> 
                </div>
            </div>
            <div class="col-md-1" v-else></div> 
            <div :class="cambio_solicitud == 0 ? 'col-md-3 mt-4' : 'col-md-5 mt-4'" :style="isMobile ? '' : 'margin-left: -77px;  z-index:1;'">
               <center>
                <template v-if="cambio_solicitud == 1">
                  <h4 style="color:#E63780;"><b>Nuevas Solicitudes</b></h4>
                </template>
                <template v-if="cambio_solicitud == 2">
                  <h4 style="color:#F28D15;"><b>En proceso</b></h4>
                </template>
                <template v-if="cambio_solicitud == 0">
                  <h4 style="color:#A13EA1;"><b>Cerradas</b></h4>
                </template> 
               </center>
            </div>
            <div class="col-md-2 mt-4">
                 <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#019DF4; border-color:#019DF4;" 
                    @click="descargaReporte(cambio_solicitud)">
                    <template v-if="cambio_solicitud == 1">Reporte nuevas solicitudes</template>
                    <template v-if="cambio_solicitud == 2">Reporte solicitudes en proceso</template>
                    <template v-if="cambio_solicitud == 0">Reporte solicitudes cerradas</template> <i class="fas fa-download ml-3"></i>
                    <b-spinner small v-if="loaderR"></b-spinner>
                  </button> 
            </div>
          </div>
        </div>
        <div class="table-responsive mt-3">
            <table class="table table-hover table-striped mt-3" >
                <thead class="bg-primary text-white">
                <tr> 
                    <th scope="col" style="font-size:17px; width: 4%;" class="text-center"></th>
                    <th scope="col" style="font-size:17px; width: 4%;" class="text-center">Folio</th>
                    <th scope="col" style="font-size:17px;" class="text-center">Nombre</th>
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud != 2">DI</th> 
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud == 1">Distribuidor</th>
                    <th v-if="isMobile"></th>
                    <th scope="col" style="font-size:17px;" class="text-center">Fecha</th> 
                    <th v-if="isMobile"></th>
                    <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud != 1">Estatus</th>  
                    <th v-if="cambio_solicitud == 2 && isMobile"></th> 
                    <th  scope="col"  v-if="cambio_solicitud == 2 && isMobile" :style="isMobile ? 'font-size:17px;' : 'font-size:17px;   width: 30%;'"  class="text-center">Opciones</th>
                    <th scope="col" :style="isMobile ? 'font-size:17px;' : 'font-size:17px;   width: 20%;'" class="text-center" v-if="cambio_solicitud == 2 && !isMobile"></th>
                    <th v-if="cambio_solicitud == 2 && isMobile"></th>  
                     <th scope="col" style="font-size:17px;" class="text-center" v-if="cambio_solicitud != 1"></th> 
                    <th scope="col" style="font-size:17px;  width: 30%;" class="text-center" v-if="cambio_solicitud != 1">Comentarios</th>
                    <th scope="col" :style="isMobile ? 'font-size:17px;' : 'font-size:17px;   width: 12%;'" class="text-center" v-if="cambio_solicitud != 2"></th>  
                    <th v-if="isMobile"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="list in listado" :key="list.id" v-show="list.historico == historico">
                  <td class="text-center"></td>  
                    <td class="text-center">
                      <b>{{list.id}}</b>
                    </td>  
                    <td class="text-center">
                      <template v-if="list.tipo_solicitud">
                        {{list.tipo_solicitud}} - <b>{{ list.idpdv }}</b>
                      </template>
                      <template>
                       {{list.nombre_solicitud}}
                      </template>
                    </td>
                    <td class="text-center" v-if="cambio_solicitud != 2"><template v-if="!list.tipo_solicitud || list.tipo_solicitud == 'Reasignar DI al IDPDV'">{{list.di}}</template></td>
                    <td class="text-center" v-if="cambio_solicitud == 1"><template v-if="!list.tipo_solicitud || list.tipo_solicitud == 'Reasignar DI al IDPDV'">{{list.nombre_distribuidor}}</template></td> 
                    <td :colspan="isMobile ? '3' : ''" class="text-center">{{list.updated_at | fechaFormato}}</td> 
                    <td class="text-center" v-if="cambio_solicitud == 2">
                      <h5 style="color:#F28D15;" v-if="list.cancelado == 0">En proceso</h5> 
                      <h5 style="color:#E63780;" v-if="list.cancelado == 1">Rechazada</h5> 
                    </td> 
                    <td class="text-center" :style="list.cancelado == 0 ? 'color:#A13EA1;' : 'color:#E63780;'" v-else-if="cambio_solicitud == 0">
                      <template v-if="list.tipo_solicitud">
                        <h5 style="color:#A13EA1;" v-if="list.cancelado == 0">Cerrado</h5>  
                        <h5 style="color:#E63780;" v-if="list.cancelado == 1">Rechazado</h5>  
                      </template>
                      <template v-else>
                        <h5 style="color:#A13EA1;" v-if="list.cancelado == 0">IDPDV enviado</h5>  
                        <h5 style="color:#E63780;" v-if="list.cancelado == 1">IDPDV rechazado</h5>  
                      </template>
                      
                      <hr>
                      <template  v-if="list.cancelado == 0 && !list.tipo_solicitud">{{ list.idpdv }}</template>
                      <template  v-if="list.cancelado == 1">Folio cerrado</template>
                    </td>  
                    <td :colspan="cambio_solicitud == 2 && isMobile  ? '3' : ''" class="text-center" v-if="cambio_solicitud == 2">
                         <div class="row justify-content-center">
                            <div class="col-md-4 col-12" v-if="list.cancelado == 0" >
                              <button v-if="list.cancelado == 0" class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#019DF4; border-color:#019DF4;" 
                                @click="aceptarSol(list)">
                                Enviar
                              </button> 
                            </div>
                            <div class="col-md-4" v-if="list.cancelado == 0" >
                              <br v-if="isMobile"> 
                              <button class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#E63780; border-color:#E63780;" 
                                @click="rechazarSol(list)">
                                Rechazar
                              </button>  
                            </div>
                            <div class="col-md-4">
                              <br v-if="isMobile"> 
                              <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615;" 
                                @click="abrirDetalle(list)">
                                Detalle
                              </button> 
                            </div>
                          </div>
                    </td> 
                    <td class="text-center" v-if="cambio_solicitud != 1">
                      <template  v-if="list.cancelado == 1"><b>Motivo rechazo</b><br> {{ list.motivo_cancelado }}</template>
                    </td> 
                    <td class="text-center" v-if="cambio_solicitud != 1">
                       <b-card  style="border-color: #d6d8db;  -webkit-border-radius: 20px;">
                          <div class="text-left"> 
                                <template v-if="list.comentario.length > 0">
                                    <b><b-avatar :style="list.comentario[0].iduser == user.id  ? 'background: #3ABF30;' : 'background: #000;'" size="sm"></b-avatar>
                                         <template v-if="list.comentario[0].user.gestor_idpdv == 1"> Usuario - {{ list.comentario[0].user.nombre }}</template>
                                         <template v-if="list.comentario[0].user.gestor_idpdv == 2"><span v-if="list.comentario[0].rechazo == 1"> Motivo Rechazo</span><span v-else> Administrador</span></template> 
                                    </b>
                                    <div class="row">
                                        <div class="col-1"></div>
                                        <div class="col-11 col-lg-12">
                                         <p :style="!isMobile ? 'text-indent: 1.7em;' : ''">{{list.comentario[0].comentario}} <em style="font-size:small;">({{list.comentario[0].created_at | fechaFormato}}) </em></p>
                                        </div>
                                   </div>
                                </template>
                                <template v-else>
                                  <span style="color:#999999; font-size: 18px;">No hay comentarios.</span>
                                </template>
                            </div>
                            <div class="row" style="margin-top: -20px;">
                                <div class="col-md-4"></div> 
                                <div class="col-md-7 text-right">
                                  <br>
                                    <u style="cursor: pointer; color: #3ABF30; font-size: 14px;"  @click="verMensaje(list)">Comentarios</u> 
                                </div>
                            </div>  
                        </b-card>
                    </td>   
                    <td :colspan="isMobile ? '2' : ''" class="text-center" v-if="cambio_solicitud != 2">
                      <div class="d-flex">
                       <button  class="btn float-center btn-sm btn-block" type="button" :style="isMobile ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 120%;' :
                           'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 60%;'" 
                            @click="abrirDetalle(list)">
                            Detalle
                          </button> 
                         <b-button @click="envioHist(list.id)" pill size="sm" variant="outline-secondary" class="ml-5" title="Enviar a historico" v-if="list.estatus == 0 &&list.historico == 0">
                          <i class="fas fa-folder"></i>
                        </b-button>
                      </div>
                    </td> 
                </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="col-md-12" v-for="list in listado" :key="list.id" v-show="list.estatus == 1" style="background: #FCFCFC; box-shadow: inset 0 0 10px 0 #CDCDCD;">
            <center>
                <br>
               <h4 style="color:#098FD6; ">No hay registros.</h4> 
                <div class="col-md-4" v-if="listado.length == 0">
                    <hr style="border-top: 5px solid #CAF5A8 !important;  opacity :2;">
                </div>
            </center>
        </div> -->
        <br><br> 
    </div> 
  </div>  

    <b-modal id="nuevoidpdv" :title="obj.tipo_solicitud ? 'AUTORIZAR SOLICITUD PARA EDICIÓN y/o BAJA DE IDPDV' : 'Enviar nuevo IDPDV'" hide-footer size="lg" > 
      <div class="row justify-content-center">  
        <div class="col-10">
          <center>
              <p>Estimado usuario:</p>
              <b v-if="obj.user">{{obj.user.email}}</b> <br><br>
              <p>Te informamos que se ha autorizado tu solicitud.</p>
              <template v-if="!obj.tipo_solicitud">
                <p>A continuación te enviamos el nuevo IDPDV:</p><br>
                <b-form-input placeholder="Escribe aquí el nuevo IDPDV" v-model="nuevo_idpdv" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
                <br>
              </template>
                  <button  class="btn float-center btn-sm mt-2 btn-block" type="button" 
                   :style="isMobile ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 60%;' : 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 20%;'" 
                    @click="enviaAurotiza()">
                    Enviar <b-spinner small v-if="loader"></b-spinner>
                  </button> 
            </center>
          </div>    
      </div>  
    </b-modal>

    <b-modal id="rechazaidpdv" :title="obj.tipo_solicitud ? 'RECHAZAR SOLICITUD PARA EDICIÓN y/o BAJA DE IDPDV' : 'Rechazar solicitud para nuevo IDPDV'" hide-footer size="lg" > 
      <div class="row justify-content-center">  
        <div class="col-10">
          <center>
              <p>Estimado usuario:</p>
              <b v-if="obj.user">{{obj.user.email}}</b> <br><br>
              <p>Te informamos que tu solicitud ha sido rechazada por el siguiente motivo.</p> 
              <b-form-input placeholder="Escribe aquí el motivo de rechazo" v-model="motivo_rechazo" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/>
              <br> 
              <div class="row  justify-content-center">
                <div class="col-md-4">
                  <button  class="btn float-center btn-sm mt-2 btn-block" type="button" 
                    :style="isMobile ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 60%;' : 'font-size:16px; color:#fff; border-radius: 26px;  background:#5CB615; border-color:#5CB615; width: 90%;'" 
                      @click="enviaRechaza()">
                      Continuar proceso <b-spinner small v-if="loader"></b-spinner>
                  </button> 
                </div>
                <div class="col-md-4">
                  <button  class="btn float-center btn-sm mt-2 btn-block" type="button" 
                    :style="isMobile ? 'font-size:16px; color:#fff; border-radius: 26px;  background:#E63780; border-color:#E63780; width: 60%;' : 'font-size:16px; color:#fff; border-radius: 26px;  background:#E63780; border-color:#E63780; width: 90%;'" 
                      @click="enviaRechaza2()">
                      Cerrar folio <b-spinner small v-if="loader2"></b-spinner>
                  </button> 
                </div>
              </div> 
              <br>
            </center>
          </div>    
      </div>  
    </b-modal>


    <b-modal id="detalle_solicitud" :title="obj.tipo_solicitud ? 'INFORMACIÓN EDICIÓN y/o BAJA DE IDPDV FOLIO ' + obj.id : 'DETALLE SOLICITUD FOLIO ' + obj.id" hide-footer   size="lg"  >
      <div class="row justify-content-center">
        <div  class="col-md-10 text-center" style="font-size: 19px;">
           <template v-if="obj.tipo_solicitud">
            <b>Nombre solicitud: </b> {{ obj.nombre_idpdv }} <br>
            <b class="mt-2">IDPDV: </b> {{ obj.idpdv }} <br>
            <b>Tipo solicitud: </b> {{ obj.tipo_solicitud }} <br>
            <template v-if="obj.user">
              <b class="mt-2">Correo del solicitante: </b> {{ obj.user.email }} <br>  
            </template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">DI Actual: </b> {{ obj.di }} <br></template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">Nuevo DI: </b> {{ obj.di_nuevo }} <br></template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">Nombre DI Actual: </b> {{ obj.nombre_distribuidor }} <br></template>
             <template v-if="obj.tipo_solicitud == 'Reasignar DI al IDPDV'"><b class="mt-2">Nuevo Nombre: </b> {{ obj.nombre_di_nuevo }} <br></template>
          </template>
          <template v-else>
            <b>Nombre solicitud: </b> {{ obj.nombre_solicitud }} <br>
            <b class="mt-2">DI: </b> {{ obj.di }} <br>
            <b class="mt-2">Nombre distribuidor: </b> {{ obj.nombre_distribuidor }} <br>
            <b class="mt-2">Calle y Número: </b> {{ obj.calle_numero }} <br>
            <b class="mt-2">NIR / Zona: </b> {{ obj.nir_zona }} <br>
            <b class="mt-2">Municipio: </b> {{ obj.municipio }} <br>
            <b class="mt-2">Estado: </b> {{ obj.estado }} <br>
            <b class="mt-2">C.P.: </b> {{ obj.cp }} <br>
            <template v-if="obj.tipo_proyecto"><b class="mt-2">Tipo Proyecto: </b> {{ obj.tipo_proyecto }} <br></template>
            <template v-if="obj.tipo_idpdv"><b class="mt-2">Tipo IDPDV: </b> {{ obj.tipo_idpdv }} <br></template>
              <template v-if="obj.tipo_proyecto == 'Prepago masivo'"><b class="mt-2">Tipo Modelo: </b> {{ obj.tipo_modelo }} <br> </template>
            <template v-if="obj.user">
            <b class="mt-2">Correo del solicitante: </b> {{ obj.user.email }} <br>  
            </template>
          </template>
          <div class="row justify-content-center mt-3">
            <div class="col-md-4 mt-3" v-for="list in obj.archivo" :key="list.id">
              <!-- <img crossorigin="anonymous" :src="$api.baseUriFiles+'gestor/' + list.testigo" alt="Image"  :width="isMobile ? 250 : 400"> -->
               <a target="_blank" :href="$api.baseUriFiles+'gestor/' + list.testigo"><u style="font-size: 22px; color:#019DF4; cursor: pointer;">Testigo</u></a>
            </div>
          </div> 
          <br>
          <center v-if="cambio_solicitud == 1">
            <button  class="btn float-center btn-sm mt-2 btn-block" type="button" style="font-size:16px; color:#fff; border-radius: 26px;  background:#F28D15; border-color:#F28D15; width: 40%;" 
              @click="procesarSolicitud()">
              Procesar  <b-spinner small v-if="loader == true"></b-spinner>
            </button> 
          </center>
        </div> 
      </div>
    </b-modal>


    <b-modal id="historialprueba" title="Comentarios" hide-footer size="lg" hide-header>
        <div class="row">
          <div class="col-md-11"></div>
          <div class="col-md-1"><u class="mt-3" style="color:#fff; cursor: pointer; font-size:20px;" @click="$bvModal.hide('historialprueba')">X</u></div> 
        </div> 
        <div class="text-center"> 
          <h4 class="text-white mt-2">COMENTARIO</h4>
        </div>
        <div class="row justify-content-center" v-if="cambio_solicitud != 0">
            <div :class="isMobile ? 'col-12' : 'col-md-10 mt-3'">
                <input type="text" class="form-control" placeholder="Nuevo comentario" v-model="comentario_seccion" style="border-radius: 30px;">
            </div> 
            <div class="col-md-3 mt-3 text-center">
             <u style="color:#fff; cursor: pointer; font-size: 20px;" @click="enviarComentario()">Enviar <b-spinner small v-if="loaderComent"></b-spinner></u>  
            </div>
        </div>
        <div class="text-left">
            <div id="global" class="mt-3">
                <div id="mensajes" v-for="com in arrayComent" :key="com.id">
                    <div class="texto">
                        <b><b-avatar :style="com.iduser == user.id ? 'background: #3ABF30;' : 'background: #000;'" size="sm"></b-avatar>
                           <template v-if="com.user.gestor_idpdv == 1"> Usuario - {{ com.user.nombre }}</template>
                           <template v-if="com.user.gestor_idpdv == 2"><span v-if="com.rechazo == 1"> Motivo Rechazo</span><span v-else> Administrador</span></template> 
                         </b>
                         <div class="row">
                             <div class="col-1"></div>
                             <div class="col-11 col-lg-12">
                                <p :style="!isMobile ? 'text-indent: 1.7em;' : ''">{{com.comentario}} <em style="font-size:small;">({{com.created_at | fechaFormato}}) </em>   </p> 
                             </div>
                         </div> 
                    </div>                             
                </div>
            </div>
        </div>
    </b-modal>
 
</div>
</template>
<script>
import Swal from 'sweetalert2' 
import moment  from 'moment'; 
export default {
 name:"Listado", 
  data() {
    return {
        arrayList:[],
        buscar:"",
        arrayPromo:[],
        motivo:"",
        idpromo:0,
        cantidad:"",
        fecha:"",
        exh:moment().format("YYYY-MM-DD"),
        tab:3,  
        isMobile: this.$mobile(),  
        fecha_entrega:"",
        identrega:"",
        testigo:0,
        arrayPros:[],
        idedit:0,
        loaderR:false,
        loaderR1:false,
        incidencia:"",
        val:0,
        testigoImg:[],
        // 
        cambio_solicitud:1,
        obj:{},
        loader:false,
        loader2:false,
        comentario_seccion:"",
        nombre_archivo:"",
        archivo_comentario:"",
        loaderComent:false,
        arrayComent:[],
        nuevo_idpdv:"",
        motivo_rechazo:"",
        historico:0
    }
  },
    filters: {
        fechaA:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        fechaFormato:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD  LTS')
            }
        },
    },
  computed:{
    user() {
        return this.$store.getters.getInfoUser;
    },
    listado(){
        
            if (this.buscar == "") {          
                return this.arrayList;
            }else{
                return   this.arrayList.filter(item => {
                        return  item.nombre_solicitud?.toLowerCase().includes(this.buscar.toLowerCase())  ||
                                item.id?.toString().toLowerCase().includes(this.buscar.toLowerCase())
                        ;
                });
            }  
        

    },
  },
  methods: {   
    cambioSelect(id){
      this.arrayList = [];
      this.cambio_solicitud = id;
      this.historico = 0;
      this.listadoAct();
    },
    abrirDetalle(item){
      this.obj = item;
      this.$bvModal.show('detalle_solicitud');
    },
    responderIncidencia(){
      this.val == 0 ? this.val = 1 : this.val = 0;
      window.scrollTo(0,900);
    },
    verIncidencia(item){
      this.obj = item; 
      this.val = 0;
      this.$bvModal.show('verinci');
    }, 
    cerrarTest(){  
      this.$bvModal.hide('verinci');
    },
    procesarSolicitud(){
      this.loader = true;
      var url= 'admin/gestor_prueba/procesar?id='+ this.obj.id;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data); 
                        this.loader = false;
                        this.$bvModal.hide('detalle_solicitud');
                        this.listadoAct(); 
                    }
                );
    },
    solucionarIncidencia(){
      this.loaderR = true;
      var url= 'control_promo/solucionarincidencia?id='+ this.obj.id;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                        this.val = 2;
                        this.loaderR = false;
                        this.listadoAct(); 
                    }
                );
    },
    descargaReporte(id){  
        Swal.fire({
                title: 'Descargar reporte solicitudes',
                showCancelButton: true,
                confirmButtonColor: '#3ABF30',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                   this.loaderR = true;
                   var nombre = "";
                   if (id == 1) {
                    nombre = 'nuevas_solicitudes';
                   }
                   if (id == 2) {
                    nombre = 'solicitudes_enproceso';
                   }
                   if (id == 0) {
                    nombre = 'solicitudes_cerradas';
                   }
                      this.$fileDownload(
                          this.$api.baseUri + 'admin/gestor_prueba/excel?tipo=' + id,
                          "reporte_"+ nombre + this.$getDate() + ".xlsx",
                      ).then(
                          () => {
                              this.loaderR = false;
                          }
                      )
                }
            }) 
    },
    envioHist(id){
     Swal.fire({
                title: '¿Estás seguro de enviar este registro a histórico?',
                showCancelButton: true,
                confirmButtonColor: '#3ABF30',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                   this.loader = true; 
                   var url= 'admin/gestor_prueba/historico?id='+ id;
                      this.$api.get(url).then(
                        ({data}) => {
                          console.log(data); 
                            this.loader = false; 
                            this.listadoAct(); 
                        }
                    );
                }
            }) 
    },
    descargaReporte2(){  
        Swal.fire({
                title: 'Descargar reporte incidencias',
                showCancelButton: true,
                confirmButtonColor: '#3ABF30',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                   this.loaderR1 = true;
                      this.$fileDownload(
                          this.$api.baseUri + 'control_promo/excelIncidencia?tipo=Solicitud de Promocionales',
                          "reporte_Incidencia" + this.$getDate() + ".xlsx",
                      ).then(
                          () => {
                              this.loaderR1 = false;
                          }
                      )
                }
            }) 
    },
    regresaList(){
      this.$bus.$emit("menuMuestra")
      this.testigo = 0;
      this.listadoAct();
    }, 
    verTest(item){
      this.obj = item;
      this.testigoImg = !item.testigo ? [] : item.testigo.split(","); 
      this.$bvModal.show('promos');
    } ,
    cambiaTab(id){
      this.tab = id;
    },  
    listadoAct(){
        var url= 'admin/gestor_prueba/index?user='+ this.user.id + '&val='+ this.user.gestor_idpdv + '&solicitud='+ this.cambio_solicitud;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                        this.arrayList = data.data.list; 
                    }
                );
    },
    verPromo(item){
      this.obj = item;
        var url= 'control_promo/promos?id='+ item.id;
            this.$api.get(url).then(
                    ({data}) => { 
                        this.arrayPromo = data.data.promos;
                        this.arrayComent = data.data.comentario;
                        this.testigo = 1;
                        this.$bus.$emit("menuOculta")
                        //  this.$bvModal.show('promos');
                    }
                );
    },
    fechaEstado(id){
      this.identrega = id;
      this.$bvModal.show('entrega');
    },
    aprobarEstado(){
        if (!this.fecha_entrega) {
                Swal.fire({
                      icon: 'error',
                      title: 'Aviso',
                      text: 'Datos requeridos' 
                      }) 
        } else {
            Swal.fire({
                title: '¿Estás seguro de cambiar el estatus?',
                showCancelButton: true,
                confirmButtonColor: '#3ABF30',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                    var url= 'control_promo/estatus?id='+ this.identrega + '&est='+ 1 + '&fecha='+ this.fecha_entrega;
                    this.$api.get(url).then(
                            ({data}) => { 
                              this.obj = data.data;
                              this.tab = 1;   
                              // this.testigo = 0;
                              this.motivo = "";
                                console.log(data); 
                                 this.$bvModal.hide('entrega');
                                //  this.$bvModal.hide('promos');
                                this.listadoAct(); 
                                this.verPromo(this.obj);
                                Swal.fire(
                                    "List@",
                                    "Promocional ha sido cambiado en estatus exitosamente.",
                                    'success'
                                    )
                            }
                        );             
                }
            })
        }
    },
    denegarEstado(id){
            Swal.fire({
                title: '¿Estás seguro de cambiar el estatus?',
                showCancelButton: true,
                confirmButtonColor: '#3ABF30',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                    var url= 'control_promo/estatus?id='+ id + '&est='+ 0;
                    this.$api.get(url).then(
                            ({data}) => { 
                              this.obj = data.data;
                              this.tab = 0;   
                              // this.testigo = 0;
                              this.motivo = "";
                                console.log(data); 
                                // this.$bvModal.hide('promos');
                                this.listadoAct();  
                                this.verPromo(this.obj);
                                Swal.fire(
                                    "List@",
                                    "Promocional ha sido cambiado en estatus exitosamente.",
                                    'success'
                                    )
                            }
                        );             
                }
            })
    },
    eliminaPromo(id){
            Swal.fire({
                title: '¿Estás seguro de eliminar el promocional?',
                showCancelButton: true,
                confirmButtonColor: '#3ABF30',
                cancelButtonColor: '#187abe',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed)
                {
                    var url= 'control_promo/eliminapromo?id='+ id;
                    this.$api.get(url).then(
                            ({data}) => { 
                              this.tab = 3;   
                              // this.testigo = 0;
                              this.motivo = "";
                                console.log(data); 
                                // this.$bvModal.hide('promos');
                                this.listadoAct();  
                                this.verPromo(this.obj);
                                Swal.fire(
                                    "List@",
                                    "Promocional ha sido eliminado exitosamente.",
                                    'success'
                                    )
                            }
                        );             
                }
            })
    },
    cambiarCant(id){
        this.idedit = id; 
        this.cantidad = "";
        if (this.obj.estatus == 2)
        {
           this.$bvModal.show('cantid');
        }
       
    },
    registraCantidad(){
        if (!this.cantidad) {
                Swal.fire({
                      icon: 'error',
                      title: 'Aviso',
                      text: 'Cantidad es requerida' 
                      }) 
        } else {
            var url= 'control_promo/cantidad?id='+ this.idedit + '&cantidad='+ this.cantidad;
            this.$api.get(url).then(
                    ({data}) => {
                        console.log(data); 
                        // this.obj.cantidad_entregada = this.cantidad;
                        this.$bvModal.hide('cantid'); 
                        this.idedit = 0;
                        this.cantidad = "";
                        // this.testigo = 0;
                        this.listadoAct();
                        this.verPromo(this.obj);
                        
                        Swal.fire(
                            "List@",
                            "Cantidad ha sido cambiada exitosamente.",
                            'success'
                            )
                    }
                );       
        }
    },
    cambiarFecha(id){
         var url= 'control_promo/fecha?id='+ id + '&fecha='+ this.fecha;
            this.$api.get(url).then(
                    ({data}) => {
                        console.log(data);  
                        this.fecha = "";
                        this.listadoAct(); 
                        Swal.fire(
                            "List@",
                            "Fecha ha sido cambiada exitosamente.",
                            'success'
                            )
                    }
                );      
    }, 
    registraPromo(){
       this.$bus.$emit("menuRegistro")
    },
    verMensaje(item){
      this.obj = item;
      this.getComentario();
      this.$bvModal.show('historialprueba');
    },
    getComentario(){
       var url= 'admin/gestor_prueba/comentario?id='+ this.obj.id;
            this.$api.get(url).then(
                    ({data}) => {
                      console.log(data);
                        this.arrayComent = data.data.list;
                        // this.arrayPromo = data.data.promo;
                    }
                );
    }, 
    enviarComentario(){
        if (!this.comentario_seccion)
            {
               Swal.fire({
                  icon: "error",
                  title: "Campo requerido",
                  text: "Escribe un comentario", 
                });
            }else{
              this.loaderComent = true;
               let model = this.prepareModelComent()
                    this.$api.post('admin/gestor_prueba/comentarios', model).then( response => { 
                            this.comentario_seccion = "";  
                            this.loaderComent = false;     
                            console.log(response);
                            this.getComentario();
                            this.listadoAct();  
                             Swal.fire(
                              "¡List@!",
                              "Comentario se envió exitosamente.",
                              "success"
                              )               
                        }).catch(error => {
                            this.loaderComent = false;
                            console.log(error);
                        });

            }
      },
      prepareModelComent(){
          let model = new FormData(); 
            model.append("comentario", this.comentario_seccion) 
            model.append("idgestor", this.obj.id)
            model.append("iduser", this.user.id)
            return model;
      },
      rechazarSol(item){
        this.obj = item;
        this.$bvModal.show('rechazaidpdv');
        //  Swal.fire({
        //         title: '¿Estás seguro de rechazar la solicitud?',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3ABF30',
        //         cancelButtonColor: '#187abe',
        //         confirmButtonText: 'Aceptar',
        //         cancelButtonText:'Cancelar',
        //         }).then((result) => { 
        //         if (result.isConfirmed)
        //         {
        //             var url= 'admin/gestor_prueba/rechazar?id='+ id;
        //             this.$api.get(url).then(
        //                     ({data}) => {
        //                         console.log(data); 
        //                         this.listadoAct(); 
        //                         Swal.fire(
        //                             "List@",
        //                             "Solicitud ha sido rechazada exitosamente.",
        //                             'success'
        //                             )
        //                     }
        //                 );             
        //         }
        //     })
      },
      aceptarSol(item){
        this.obj = item;
        this.nuevo_idpdv = item.tipo_solicitud ? item.idpdv : "";
        this.$bvModal.show('nuevoidpdv');
        // Swal.fire({
        //         title: '¿Estás seguro de aceptar la solicitud?',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3ABF30',
        //         cancelButtonColor: '#187abe',
        //         confirmButtonText: 'Aceptar',
        //         cancelButtonText:'Cancelar',
        //         }).then((result) => {
        //         /* Read more about isConfirmed, isDenied below */
        //         if (result.isConfirmed)
        //         {
        //             var url= 'admin/gestor_prueba/aceptar?id='+ id;
        //             this.$api.get(url).then(
        //                     ({data}) => {
        //                         console.log(data); 
        //                         this.listadoAct(); 
        //                         Swal.fire(
        //                             "List@",
        //                             "Solicitud ha sido aceptada exitosamente.",
        //                             'success'
        //                             )
        //                     }
        //                 );             
        //         }
        //     }) 
      },
      enviaAurotiza(){
        if (!this.nuevo_idpdv && !this.obj.tipo_solicitud) {
            Swal.fire({
                  icon: "error",
                  title: "Campo requerido",
                  text: "Escribe un IDPDV", 
                });
        }else{
          this.loader = true;
          var url= 'admin/gestor_prueba/aceptar?id='+ this.obj.id + '&nuevo='+ this.nuevo_idpdv;
            this.$api.get(url).then(
                    ({data}) => {
                        console.log(data); 
                        this.obj = {};
                        this.nuevo_idpdv = "";
                        this.loader = false;
                        this.$bvModal.hide('nuevoidpdv');
                        this.listadoAct(); 
                        Swal.fire(
                            "List@",
                            "La solicitud ha sido aceptada exitosamente.",
                            'success'
                            )
                    }
                );  
          }
      },
      enviaRechaza(){
        if (!this.motivo_rechazo) {
            Swal.fire({
                  icon: "error",
                  title: "Campo requerido",
                  text: "Escribe un motivo de rechazo", 
                });
        }else{
          this.loader = true;
          var url= 'admin/gestor_prueba/rechazar?id='+ this.obj.id + '&motivo='+ this.motivo_rechazo  + '&iduser='+  this.user.id;
            this.$api.get(url).then(
                    ({data}) => {
                        console.log(data); 
                        this.obj = {};
                        this.motivo_rechazo = "";
                        this.loader = false;
                        this.$bvModal.hide('rechazaidpdv');
                        this.listadoAct(); 
                        Swal.fire(
                            "List@",
                            "La solicitud ha sido rechazada exitosamente.",
                            'success'
                            )
                    }
                );          
          }
      },
      enviaRechaza2(){
        if (!this.motivo_rechazo) {
            Swal.fire({
                  icon: "error",
                  title: "Campo requerido",
                  text: "Escribe un motivo de rechazo", 
                });
        }else{
          this.loader2 = true;
          var url= 'admin/gestor_prueba/rechazar2?id='+ this.obj.id + '&motivo='+ this.motivo_rechazo  + '&iduser='+  this.user.id;
            this.$api.get(url).then(
                    ({data}) => {
                        console.log(data); 
                        this.obj = {};
                        this.motivo_rechazo = "";
                        this.loader2 = false;
                        this.$bvModal.hide('rechazaidpdv');
                        this.listadoAct(); 
                        Swal.fire(
                            "List@",
                            "La solicitud ha sido rechazada exitosamente.",
                            'success'
                            )
                    }
                );          
          }
      }
  },
  mounted(){
    this.listadoAct();  
  } 
}

</script>
<style scoped>
  #hover:hover{
    background:#B2DAFF;
  }

  #tabsCapturaPop .active {
    background: none;
    color: var(--color-primary);
    transition: all 300ms ease;
  }

  #tabsCapturaPop a {
    background: none;
    color: #85848A;
    transition: all 300ms ease;
  }
  #tabsCapturaPop a i {
    transition: all 300ms ease;
    animation-duration: 0.3s;
    font-size: 10px;
  }

  #tabsCapturaPop #capturaBtnReporte .active {
    background: #00a9e0;
    color: white;
  }

  #tabsCapturaPop #capturaBtnReporte {
    margin: 0 20px 0 20px !important;
  }
  
  .input-nav-search::placeholder {
  color: #a8a8a8;
  font-weight: lighter;
  font-family: TelefonicaLight, serif;
  font-size: 15px;
}


  #pagi a {
    background: none;
    color: #85848A;
    transition: all 300ms ease;
  }


.filepond--drop-label {
     background-color: #00a8f1 !important;
    box-shadow: 0px 10px 10px -6px black;
    cursor: pointer;
    color: #fff;
}

.flexbox {
  align-items: center;
  display: flex;
  height: 75px;
  justify-content: center;
  width: auto;
}

.flexbox2 {
  align-items: center;
  display: flex;
  height: 45px;
  justify-content: center;
  width: auto;
}

#global {
	height: 280px;
	width: 100%;
	border: 1px solid #FAFAFA;
	background: #FAFAFA;
	overflow-y: scroll;
}
#mensajes {
	height: auto;
}
</style>
